/* eslint-disable import/no-cycle */
import React from 'react'

import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Icon, { IconNames } from 'components/icons'
import theme from 'components/theme'
import { isSublosRoute } from 'helpers/routeMatchers'
import { getContext, numberWithDot } from 'helpers/utils'
import { mapMediaType } from 'selectors/mediaType'

import {
  HeaderContainer,
  HeaderText,
  IconWrapper,
  LeftContainer,
  RightContainer,
  SubContainer,
  TypeText
} from './styled'

const getToggleElement = props =>
  props.toggleElement ||
  (!props.noIcon && (
    <Icon
      name={props.isExtended ? IconNames.ChevronUp : IconNames.ChevronDown}
      color={
        props.isSublos
          ? theme.colors.blue
          : props.simplified
          ? theme.colors.blue
          : theme.colors.white
      }
      size={25}
    />
  ))

const getHeaderBackgroundColor = (props, isSublos) => {
  if (isSublos) return theme.colors.blueLighter
  if (props.simplified) return theme.colors.grayLighter
  if (props.isDisabledCalendar) return theme.colors.silver
  else return props.background
}

const CollapsibleHeader = props => {
  const { t } = useTranslation()
  const location = useLocation()
  const isSublos = isSublosRoute(location)
  return (
    <HeaderContainer
      noCenter={props.noCenter}
      withBorderBottom={props.withBorderBottom}
      customHeight={props.customHeight}
      background={getHeaderBackgroundColor(props, isSublos)}
      simplified={props.simplified}
      e2eClass={props.e2eClass}
      noLeftPadding={props.noLeftPadding}
    >
      <SubContainer>
        <LeftContainer>
          {props.icon && (
            <IconWrapper e2eClass={props.e2eClass}>
              <Icon
                name={props.icon}
                color={isSublos ? theme.colors.blue : props.textColor || theme.colors.white}
              />
            </IconWrapper>
          )}
          {props.typeTextLeft && (
            <TypeText isInactive={props.isInactive}>{props.typeTextLeft}</TypeText>
          )}
          {(props.headerText || props.headerTextKey) && (
            <HeaderText
              isInactive={props.isInactive}
              e2eClass={props.e2eClass}
              color={isSublos || props.simplified ? theme.colors.blue : props.textColor}
              as={props.renderAsHeader ? props.renderAsHeader : 'span'}
              isSublos={props.isSublos}
            >
              {props.headerText || t(props.headerTextKey)}
            </HeaderText>
          )}
        </LeftContainer>
        {props.typeTextRight && (
          <RightContainer>
            <TypeText
              noUppercase={props.noUppercase}
              isInactive={props.isInactive}
              e2eClass={props.e2eClass}
            >
              {t('label.miles', {
                context: getContext(props.typeTextRight.split(' ')[0]),
                amount: numberWithDot(props.typeTextRight.split(' ')[1]),
                currency: props.typeTextRight.split(' ')[0]
              })}
            </TypeText>
          </RightContainer>
        )}
      </SubContainer>
      {!props.notCollapsible && getToggleElement({ isSublos: isSublos, ...props })}
    </HeaderContainer>
  )
}

const mapStateToProps = state => ({
  mediaType: mapMediaType(state)
})

export default connect(mapStateToProps)(CollapsibleHeader)
